<template>
  <div>
    <a-button type="primary" danger @click="showModal">同步商品数据</a-button>
    <a-modal v-model:visible="visible" :title="'铺货成功的商品同步' + getFinalText" class="synchronization-goods-data-modal" :maskClosable="false">
      <div class="box">
        <CreateGoodsTemplateModal ref="createGoodsTemplateModal" :hideOpenDouyinButton="true" />
        <div class="goods-options">
          <span class="item-title">筛选条件:</span>
          <a-radio-group v-model:value="selectGoodsType" button-style="solid" class="margin-left-12">
            <a-radio-button v-for="item in selectGoodsOptionList" :key="item.label" :value="item.value">{{ item.label }}</a-radio-button>
          </a-radio-group>
          <a-tag v-show="selectGoodsType === 'select'" color="red">已勾选 {{ selectedRows.length }} 个商品</a-tag>
          <div v-show="selectGoodsType === 'page'">
            第 <a-input-number v-model:value="page.up" :min="1" :max="100000" placeholder="必填项" /> 页 —
            第 <a-input-number v-model:value="page.down" :min="1" :max="100000" placeholder="必填项" /> 页
          </div>
        </div>
        <div class="goods-options">
          <span class="item-title">同步设置:</span>
          <a-radio-group v-model:value="syncType" button-style="solid">
            <a-radio-button v-for="item in syncOptionList" :key="item.label" :value="item.value">{{ item.label }}</a-radio-button>
          </a-radio-group>
          <a-checkbox v-model:checked="isSyncDown">如上游商品已下架或删除则同步下架本店商品</a-checkbox>
        </div>
        <div>
          <a-tag color="red" style="line-height: 1.58">
            如查询到的【上游商品SKU名称】和【支付宝商品SKU名称】不匹配则无法同步
          </a-tag>
        </div>
      </div>
      <template #footer>
        <a-button type="primary" @click="synchronizationData">确定同步</a-button>
        <a-button type="primary" danger @click="visible = false">关闭窗口</a-button>
      </template>
    </a-modal>
    <a-modal v-model:visible="isShowLogModal" width="1000px" :title="'铺货成功的商品同步' + getFinalText + '- 日志'" style="top: 60px" :maskClosable="false">
      <LogModal ref="logModal" strType="p" />
      <template #footer>
        <a-button type="primary" ghost @click="isShowLogModal = false">关闭窗口</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import LogModal from '@/views/base/components/log_modal/log_modal'
import CreateGoodsTemplateModal from '@/views/moving_function/components/create_goods_template_modal'
import handler from './handler'
export default {
  components: { CreateGoodsTemplateModal, LogModal },
  data() {
    return {
      visible: false,
      isShowLogModal: false,
      isSyncDown: false,
      syncType: 1,
      selectGoodsType: 'page',
      page: { up: 1, down: 1 },
      syncOptionList: handler.syncOptionList,
      goodsOptionList: handler.goodsOptionList,
      selectGoodsOptionList: handler.selectGoodsOptionList
    }
  },
  props: {
    selectedRows: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    getFinalText() {
      const map = {
        0: '【库存】与【价格】',
        2: '【价格】'
      }
      return map[this.syncType] || '【库存】'
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },
    async checkData() {
      // 筛选条件选择的是根据勾选的    Status: 2 (铺货成功)
      if (this.selectGoodsType === 'select') {
        const str = '请至少勾选一个【铺货成功】'
        let list = this.selectedRows.filter(item => item.Status === 2)
        if (!list.length) return { msg: `${str}的商品` }
        return { list }
      }
      // 筛选条件选择的是根据指定页码的
      if (this.selectGoodsType === 'page') {
        if (!this.page.up || !this.page.down) return { msg: '页码是必填项' }
        if (this.page.up > this.page.down) return { msg: '开始页码不能大于结束页码' }
        const { msg, list } = await handler.GetLogList({ page: this.page.up, size: this.page.down })
        if (msg) return { msg }
        return { list }
      }
    },
    async synchronizationData() {
      const { msg, list } = await this.checkData()
      if (msg) return this.$message.warning(msg)
      this.isShowLogModal = true
      this.$nextTick(async () => {
        const log = this.$refs.logModal
        log.clear()
        log.addLog(` 筛选后共【${list.length}】个商品，正在同步${this.getFinalText}中，请耐心等待 ...`)
        await handler.SyncGoodsPriceAndStock(
          this,
          { list, type: this.syncType, templateRef: this.$refs.createGoodsTemplateModal, isSyncDown: this.isSyncDown },  
          (logMsg, hideTime) => log.addLog(logMsg, hideTime)
        )
        this.$emit('finish')
        log.addLog(` 已经执行完毕 ...`)
      })
    }
  },
  watch: {
    isShowLogModal(value) {
      if (!value) this.visible = false
    }
  }
}
</script>
<style lang='less'>
  @import './index';
</style>